var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClubIn = function SvgClubIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6971_70944",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04175 10.0003C1.04175 5.05515 5.0549 1.04199 10.0001 1.04199C10.3453 1.04199 10.6251 1.32181 10.6251 1.66699C10.6251 2.01217 10.3453 2.29199 10.0001 2.29199C5.74526 2.29199 2.29175 5.7455 2.29175 10.0003C2.29175 14.2551 5.74526 17.7087 10.0001 17.7087C14.2549 17.7087 17.7084 14.2551 17.7084 10.0003C17.7084 9.65515 17.9882 9.37533 18.3334 9.37533C18.6786 9.37533 18.9584 9.65515 18.9584 10.0003C18.9584 14.9455 14.9453 18.9587 10.0001 18.9587C5.0549 18.9587 1.04175 14.9455 1.04175 10.0003Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8923 1.2251C18.1364 0.981101 18.5321 0.981047 18.7761 1.2251C19.0201 1.46915 19.0201 1.86483 18.7761 2.10889L11.9426 8.94238C11.6986 9.18635 11.3029 9.18635 11.0588 8.94238C10.8148 8.69833 10.8148 8.30268 11.0588 8.05859L17.8923 1.2251Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2084 5.14199C10.2084 4.79681 10.4882 4.51699 10.8334 4.51699C11.1786 4.51699 11.4584 4.79681 11.4584 5.14199V8.54206H14.8585C15.2036 8.54209 15.4835 8.8219 15.4835 9.16706C15.4834 9.51218 15.2036 9.79202 14.8585 9.79206H10.8334C10.4883 9.79206 10.2084 9.51221 10.2084 9.16706V5.14199Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6971_70944)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))));
};
export default SvgClubIn;